import get from 'lodash/get';
import { takeLatest, put } from 'redux-saga/effects';
import createConsts from '../../../utils/redux/consts';
import { insuranceErrorModalActions } from '../handle-insurance-error-modal';
import { consts as checkEligibilityConsts } from '../requests/check-insurance-eligibility';
import { consts as updatePatientInsuranceConsts } from '../../manage-insurances/requests/update-patient-insurance';

function* worker({ payload }) {
  if (payload) {
    const handledErrorEntity = get(payload, 'error.meta');

    if (handledErrorEntity) {
      yield put(insuranceErrorModalActions.open({ ...handledErrorEntity }));
    } else {
      yield put({
        type: createConsts('ui', 'error', ['UPDATE']).UPDATE,
        payload: { id: 'errors.common' },
      });
    }
  } else {
    yield put({
      type: createConsts('ui', 'error', ['UPDATE']).UPDATE,
      payload: { id: 'errors.longRequest.502.504' },
    });
  }
}

function* handleInsuranceUpdateFailed() {
  yield takeLatest(
    [
      checkEligibilityConsts.REJECTED,
      checkEligibilityConsts.ERROR_ENCOUNTERED,
      updatePatientInsuranceConsts.REJECTED,
      updatePatientInsuranceConsts.ERROR_ENCOUNTERED,
    ],
    worker,
  );
}

export default handleInsuranceUpdateFailed;



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/handle-insurance-update-failed.js